import {
    ipmQueryClient,
    startNewMessage,
    useInfiniteMessageCentreDepartments
} from "@twigsby/client-data";
import {IpmRqKeys} from "@twigsby/client-data/lib/Wrappers/ReactQuery/CacheKeys";
import {
    AlertBanner,
    ButtonSubmit,
    ColourSolid, ComboBoxControl,
    FormWrapperLabel,
    Modal,
    ModalType,
    SelectItemType, UploadFile
} from '@twigsby/frontend-framework';
import React, {useEffect, useState} from "react";
import {Controller, FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";

interface CreateNewMessageModalType extends ModalType {
    selectableDepartment?: boolean;
    defaultDepartment?: number;
    placeholderMessage?: string;
    readOnlyMessage?: string;
}

const CreateNewMessageModal = (props: CreateNewMessageModalType) => {
    const{ t } = useTranslation();
    const navigate = useNavigate();

    const  {
        data,
        status
    } = useInfiniteMessageCentreDepartments();

    const formMethods = useForm({
        defaultValues: {
            subject: '',
            departmentId: props.defaultDepartment || undefined,
            text: props.placeholderMessage || undefined,
            files: undefined,
            containsHtml: false
        },
        mode: "onChange"
    });

    const {
        control,
        reset,
        formState,
    } = formMethods;

    const [departmentOptions, setDepartmentOptions] = useState<Array<SelectItemType>>([]);

    const HandleCreate = (data: any) => {
        const formData: any = new FormData();

        formData.append('subject', 'subject');
        formData.append('text', props.readOnlyMessage ? `${props.readOnlyMessage}:\n\n ${data.text}` : data.text);
        formData.append('departmentId', data.departmentId);
        formData.append('containsHtml', 'false');

        if(data.files && data.files.length > 0) {
            data.files.forEach((file: any) => {
                formData.append('files', file);
            });
        }

        console.log('formData', formData);
        /*startNewMessage(formData).then((r: any) => {
            if(r.id) {
                navigate(`/message-centre/${r.id}`);

                ipmQueryClient.invalidateQueries([IpmRqKeys.MESSAGE_CENTRE_KEY, 'all']).then(() => null);

                if(props.closeCallback) {
                    props.closeCallback()
                }
            }
        });*/
    }

    const MapDepartmentOptions = () => {
        const departmentOptions = data?.pages.map((page) => page?.data && page.data.map((item) => {
            return { label: item.name, value: item.id }
        } ))[0];

        setDepartmentOptions(departmentOptions ? departmentOptions : []);
    }

    useEffect(() =>  {
        if(data) {
            MapDepartmentOptions();
        }
    }, [data])

    useEffect(() => {
        reset();
    }, [props.isOpen]);

    return (
        <Modal title={t('messageUs.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit((data) => HandleCreate(data))}>
                    <fieldset className={'flex-column flex-gap-md'}>
                        {props.readOnlyMessage && (
                            <AlertBanner title={props.readOnlyMessage} />
                        )}

                        {!props.defaultDepartment && (
                            <Controller
                                control={control}
                                name="departmentId"
                                rules={{ required: true }}
                                render={({field, fieldState}) =>
                                    <FormWrapperLabel
                                        label={t('messageUs.labels.department')}
                                        invalid={fieldState.invalid}
                                        validationMessage={fieldState.error?.message}
                                    >
                                        <ComboBoxControl
                                            name={'departmentId'}
                                            data={departmentOptions}
                                            placeholder={t('messageUs.controls.departmentPlaceholder')}
                                            loading={status === 'loading'}
                                            valueType={'number'}
                                            singleSelection={true}
                                            defaultValues={props.defaultDepartment ? [props.defaultDepartment] : undefined}
                                            forwardValueCallback={(e: any) => {
                                                field.onChange(e);
                                            }}
                                        />
                                    </FormWrapperLabel>
                                }
                            />
                        )}

                        <Controller
                            control={control}
                            name="text"
                            rules={{ required: true,  minLength: { value: 2, message: t('validation.tooShort')} }}
                            render={({field, fieldState}) =>
                                <FormWrapperLabel
                                    label={t('messageUs.labels.message')}
                                    invalid={fieldState.invalid}
                                    validationMessage={fieldState.error?.message}
                                >
                                    <textarea
                                        defaultValue={props.placeholderMessage}
                                        rows={10}
                                        aria-invalid={formState.errors.text ? 'true' : 'false'}
                                        onChange={(e) => field.onChange(e.currentTarget.value)}
                                     />
                                </FormWrapperLabel>
                            }
                        />

                        <Controller
                            control={control}
                            name="files"
                            render={({ field, fieldState }) =>
                                <div>
                                    <FormWrapperLabel
                                        label={t('messageUs.labels.file')}
                                        invalid={fieldState.invalid}
                                        validationMessage={fieldState.error?.message}
                                    />
                                    <UploadFile
                                        onChange={(e) => field.onChange(e)}
                                    />
                                </div>
                            }
                        />

                        <ButtonSubmit title={t('messageUs.actions.send')} colour={ColourSolid.Primary} fullWidth={true} disabled={!formState.isValid}/>
                    </fieldset>
                </form>
            </FormProvider>
        </Modal>
    )
}

export default CreateNewMessageModal
